import { useContext } from 'react';

import FormContext from '../../components/form/FormContext';

const useFormContext = () => {
  const formContext = useContext(FormContext);
  return formContext;
};

/**
 * @visibleName useFormContext
 * @component
 */
export default useFormContext;
